var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { class: `${_vm.$options.name}` },
    [
      _c("section", { class: `${_vm.$options.name}-filter` }, [
        _c("label", [_vm._v("Postcodes")]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.descriptions.shippingRegionPostcodes))]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.postcodesFilter,
              expression: "postcodesFilter",
            },
          ],
          staticClass: "postcodes-filter",
          attrs: {
            type: "text",
            id: "postcodes-filter",
            placeholder: "Type to filter postcodes",
          },
          domProps: { value: _vm.postcodesFilter },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.postcodesFilter = $event.target.value
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "Chipset",
        { attrs: { label: "Metro Postcodes:", variant: "metro" } },
        [
          _c("vue-tags-input", {
            attrs: {
              tags: _vm.tags("metro"),
              "allow-edit-tags": _vm.editAllowed,
              disabled: !_vm.editAllowed,
              "add-on-key": [13, ":", ";", 32],
              placeholder: "Add Metro Postcode.",
            },
            on: {
              "tags-changed": (newTags) => {
                if (!_vm.postcodesFilter.length) {
                  _vm.metroTagset = newTags
                }
              },
              "before-adding-tag": (payload) => _vm.checkTag(payload, "metro"),
              "before-saving-tag": (payload) => _vm.saveTag(payload, "metro"),
            },
            model: {
              value: _vm.metroTag,
              callback: function ($$v) {
                _vm.metroTag = $$v
              },
              expression: "metroTag",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Chipset",
        { attrs: { label: "Non Metro Postcodes:", variant: "nonmetro" } },
        [
          _c("vue-tags-input", {
            attrs: {
              placeholder: "Add Non Metro Postcode",
              tags: _vm.tags("nonMetro"),
              "allow-edit-tags": _vm.editAllowed,
              disabled: !_vm.editAllowed,
              "add-on-key": [13, ":", ";", 32],
            },
            on: {
              "tags-changed": (newTags) => {
                if (!_vm.postcodesFilter.length) {
                  _vm.nonMetroTagset = newTags
                }
              },
              "before-adding-tag": (payload) =>
                _vm.checkTag(payload, "nonMetro"),
              "before-saving-tag": (payload) =>
                _vm.saveTag(payload, "nonMetro"),
            },
            model: {
              value: _vm.nonMetroTag,
              callback: function ($$v) {
                _vm.nonMetroTag = $$v
              },
              expression: "nonMetroTag",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }